<template>
  <section id="spare-parts" class="bg-light">
    <div class="container">
      <div class="col-lg-12 text-center">
        <h3 class="text-muted section-subheading"></h3>
        <h2 class="text-uppercase section-heading" id="accessories">ΕΞΑΡΤΗΜΑΤΑ<br/></h2>
        <div class="section-subheading text-muted">
          Ανταλλακτικά και εξαρτήματα διάφορων εταιριών σε μεγάλη ποικιλία.
          <br/>
          Επιστόμια Vandoren, Selmer, Rico, Amati, Bach, Schilke, Conn, Denis Wick, Giardinelli, Stork, Gewa,
          Yanagisawa. Σουρτίνες Denis Wick, H&amp;B, Joral,
          Bach Elite, Tom Crown.
          <br/>
          Θήκες μουσικών οργάνων, Ortola, Buffet Crampon, Keilwerth.
          <br/>
          Ιμάντες, ζώνες, ελατήρια χάλκινων, βάσεις, αναλόγια, προφυλακτήρες, σφυκτήρες, βαρέλια, μαγνήτες, κλπ.
        </div>
        <br/>
        <h3 class="section-subheading text-muted"><em> </em><br/></h3>
      </div>
      <div class="row">
        <div v-for="part in spare_parts" v-bind:key="part.id" class="col-sm-4">
          <div class="team-member">
            <img class="rounded-circle mx-auto" :src="fixPath(part.image)" :alt="part.description"/>
            <h4>{{ part.title }}</h4>
            <p class="text-muted">{{ part.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="consumables" class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h3 class="text-muted section-subheading"></h3>
          <h2 class="text-uppercase section-heading" id="accessories">ΑΝΑΛΩΣΙΜΑ<br/></h2>
          <div class="section-subheading text-muted">
            Αναλώσιμα διάφορων εταιρειών σε μεγάλη ποικιλία.
            <br/>
            Λιπαντικά Selmer, Bach, Conn, Holton, Getzen, Slide-O-Mix, Superslic.
            <br/>
            Καλαμάκια κλαρίνου, σαξοφώνου Vandoren, Rico Royal, Hot&amp;Swing, Selmer
            <br/>
            Καθαριστικά BG, Selmer, Gewa, Trevor James.
          </div>
          <br/>
        </div>
        <div v-for="consumable in consumables" v-bind:key="consumable.id" class="col-sm-4">
          <div class="team-member">
            <img class="rounded-circle mx-auto" :src="fixPath(consumable.image)"/>
            <h4>{{ consumable.title }}</h4>
            <p class="text-muted">{{ consumable.description }}<br/><br/></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import spareParts from '@/data/spare_parts.json'
import consumablesData from '@/data/consumables.json'

export default {
  name: "AppParts",
  data() {
    return {
      spare_parts: spareParts.items,
      consumables: consumablesData.items
    }
  },
  methods: {
    fixPath(path) {
      if (!path || path.startsWith('/')) return path;
      const withProtocol = path.startsWith('http') ? path : 'https://' + path;
      try {
        return new URL(withProtocol).pathname.replace(/^\/public\//, '/');
      } catch {
        return path;
      }
    }
  }
};
</script>

<style scoped></style>
